<template>
  <section>
    <div>
      <v-flex v-show="false" xs3 md3> 
        <v-tooltip bottom>
        <v-btn
          slot="activator"
          large
          dark
          color="#a358c8"
          :href="'https://drive.economiayfinanzas.gob.bo/index.php/s/fppNJkj8RNAn4Qa'"
          target="_blank"
        >
          <v-icon>videocam</v-icon> VIDEO TUTORIALES
        </v-btn>
        <span>Ver videotutoriales del sistema de RRHH</span>
      </v-tooltip>
      </v-flex>
      <v-flex v-show="false" xs9 md9> </v-flex>
      <v-flex v-show="false" xs2 md4>
        <h5 class:titulo_qr> QR para descargar la aplicación móvil</h5>
         </v-flex>
      <v-flex v-show="false" xs2 md4>
        <img src="@/assets/images/QR-SIAP.jpg" alt="" height="170" />
      </v-flex>
      <v-flex v-show="false" xs4 md6>
        <h5 class:titulo_qr>V.1.1 </h5>
         </v-flex>

    </div>
    <div class="login-container">
      <!-- <div class="logo-app"></div> -->
      <div class="title-app">
        <h2>SAP</h2>
        <h1>Sistema de Administración de Personal</h1>
        <h4>Administracion de Servicios Portuarios - Bolivia</h4>
      </div>
      <v-card class="login-form">
        <v-form
          @submit.prevent="submit"
          v-model="valid"
          ref="form"
          lazy-validation
        >
          <v-card-title primary-title>
            <h4>{{ $t("login.title") }}</h4>
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    name="username"
                    :label="$t('login.user')"
                    id="username"
                    append-icon="person"
                    v-model="form.username"
                    autofocus
                    maxlength="25"
                    :rules="$validate(['required'])"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    name="password"
                    :label="$t('login.password')"
                    id="password"
                    :append-icon="getIcon"
                    @click:append="changeIcon"
                    :type="hidePass ? 'password' : 'text'"
                    v-model="form.password"
                    maxlength="100"
                    :rules="$validate(['required'])"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-title>
          <v-card-actions>
            <v-btn
              color="primary"
              block
              large
              :disabled="!valid"
              type="submit"
              >{{ $t("login.login") }}</v-btn
            >
          </v-card-actions>
          <v-card-title  v-show="false">
            <v-container fluid>
              <v-layout row class="login-options">
                <v-flex xs5>
                  <v-checkbox :label="$t('login.rememberMe')" v-model="remember" color="primary"></v-checkbox>
                </v-flex>
                <v-flex xs7>
                  <div class="text-xs-right">
                    <a @click="goToPasswordRecovery()">
                      <v-icon>lock_outline</v-icon> {{ $t('login.forgotPass') }}
                    </a>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-title>

          <!-- <v-card-title class="info">
            <a href="" class="white--text">{{ $t('login.signUp') }}</a>
          </v-card-title> -->
        </v-form>
      </v-card>
      <!-- <div class="contactos">
        <a href="mailto:entidad@gob.bo">Contactar</a>
      </div> -->
      <div class="text-xs-center mt-3">
        <router-link v-show="false" to="/password-recovery">Restablecer </router-link> 
        <router-link v-show="false" to="/loginlock">Login Lock</router-link> 
        <router-link v-show="false" to="/login-nit">Login NIT</router-link> 
        <router-link v-show="false" to="/login-ciudadania">Login Ciudadania</router-link>
      </div> 
    </div>
    <div class="login-lang">
      <app-lang></app-lang>
    </div>
  </section>
</template>

<script>
import Auth from "./mixins/auth";
import AppLang from "@/common/layout/AppLang";
import validate from "@/common/mixins/validate";

export default {
  mixins: [Auth, validate],
  data() {
    return {
      valid: true,
      form: {
        username: "",
        password: "",
      },
      hidePass: true,
      remember: false,
    };
  },
  methods: {
    changeIcon() {
      if (this.form.password.length) {
        this.hidePass = !this.hidePass;
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.login(this.form);
        //this.loginWithKeyCloack(this.form);
      }
    },
    goToPasswordRecovery() {
      ////// 
      console.log('recuperar cuenta....');
      this.$router.push('/password-recovery');
    }
  },
  components: { AppLang },
  computed: {
    getIcon() {
      return this.form.password.length === 0
        ? "lock"
        : this.hidePass
        ? "visibility"
        : "visibility_off";
    },
  },
  mounted() {
    if (this.$storage.exist("error")) {
      this.$message.error(this.$storage.get("error"));
      this.$storage.remove("error");
    }
  },
  watch: {
    "form.password": function (val) {
      if (val.length === 0) {
        this.hidePass = true;
      }
    },
  },
};
</script>

<style src="./login.scss" lang="scss">
.titulo_qr {
  color: rgb(3, 3, 3);
  align-content: center;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/auth/Login.vue